import Mixpanel from '@/integrations/Mixpanel';
import MixpanelEvent from '@/integrations/Mixpanel/MixpanelEvent';
import type { RouteLocationNormalized } from 'vue-router';

export function afterEachGuard(to: RouteLocationNormalized) {
  //fixup title
  if (to?.meta?.name) {
    document.title = `${String(to.meta.name)}`;
  }

  const pageViewEvent = MixpanelEvent.createPageViewEvent(to);
  Mixpanel.instance.track(pageViewEvent);
}
